import { render } from "./InstructorKeywords.vue?vue&type=template&id=13861002&scoped=true"
import script from "./InstructorKeywords.vue?vue&type=script&lang=js"
export * from "./InstructorKeywords.vue?vue&type=script&lang=js"

import "./InstructorKeywords.vue?vue&type=style&index=0&id=13861002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13861002"]])

export default __exports__